module.exports = "/images/smile.svg?cce205ca76361a9b919aeeaf0fd0e9ae";